/** Layout height reclaimed when the mobile sticky page header collapses. */
export const MOBILE_PAGE_HEADER_COLLAPSED_HEIGHT_PX = 52;

/** Duration for chrome dismiss/restore (keyboard-like). */
export const CHROME_DISMISS_DURATION_MS = 280;

export const MOBILE_POSTURE_TOOLBAR_HEIGHT_PX = 44;

/** View tab row (Anterior / Posterior / …) in mobile posture split. */
export const MOBILE_POSTURE_VIEW_TABS_HEIGHT_PX = 48;

/** View Report | Posture segment row in mobile split (B2 chrome). */
export const MOBILE_POSTURE_ANALYSIS_SEGMENT_HEIGHT_PX = 44;

/** Mobile SOP action toolbar: two `h-11` rows + `gap-3` between them. */
export const MOBILE_SOP_TOOLBAR_STACK_HEIGHT_PX = 100;

/** Fixed bottom nav (`h-14`) + typical safe-area padding on `main`. */
export const MOBILE_BOTTOM_NAV_RESERVE_PX = 80;

/** BottomNav bar height (`h-14`). */
export const MOBILE_BOTTOM_NAV_HEIGHT_PX = 56;

/**
 * Mobile immersive chrome applies to all PageLayout routes except Dashboard and Chat.
 */
export function isMobileImmersiveChromeRoute(pathname: string): boolean {
  if (pathname === '/dashboard' || pathname.startsWith('/dashboard/')) return false;
  if (pathname === '/chat' || pathname.startsWith('/chat/')) return false;
  return true;
}

/** Posture capture UI adds toolbar + view tabs + analysis chrome to the dismiss stacks. */
export function isPostureExtendedChromeRoute(pathname: string): boolean {
  return pathname.includes('/posture-analysis');
}

/** SOP assessment mobile action rows (P/A, Save, VGon, etc.) dismiss with bottom chrome. */
export function isSopExtendedChromeRoute(pathname: string): boolean {
  if (pathname === '/sop-assessment' || pathname === '/sop-assessment-legacy') return true;
  if (/\/assessment\/new\/?$/.test(pathname)) return true;
  if (/\/assessment\/[^/]+\/edit\/?$/.test(pathname)) return true;
  return false;
}

/** Height of posture B1+B2 rows above bottom nav (for dismiss tap band placement). */
export function mobilePostureBottomChromeStackHeightPx(): number {
  return MOBILE_POSTURE_VIEW_TABS_HEIGHT_PX + MOBILE_POSTURE_ANALYSIS_SEGMENT_HEIGHT_PX;
}

/**
 * Distance from viewport bottom to the immersive dismiss tap band (chrome visible).
 */
export function mobileChromeDismissBottomOffsetPx(options: {
  isPostureExtendedChrome: boolean;
  isSopExtendedChrome: boolean;
  isChromeHidden: boolean;
}): number {
  if (options.isChromeHidden) {
    return 0;
  }
  let stackAboveNav = 0;
  if (options.isPostureExtendedChrome) {
    stackAboveNav = mobilePostureBottomChromeStackHeightPx();
  } else if (options.isSopExtendedChrome) {
    stackAboveNav = MOBILE_SOP_TOOLBAR_STACK_HEIGHT_PX;
  }
  return MOBILE_BOTTOM_NAV_HEIGHT_PX + stackAboveNav;
}
